<br>
<div class="row">
    <div class="col-sm-6">
        <div style="text-align: right;" *ngIf="WriteCompliance">
            <button  mat-raised-button color="primary" (click)="add()">
                Add
            </button>
        </div>
        <table mat-table matSort matSortActive="sportSeason" matSortDirection="desc" matSortDisableClear [dataSource]="dataSource" style="width: 100%;">
            <ng-container matColumnDef="sportType">
                <th mat-header-cell  *matHeaderCellDef mat-sort-header> Sport </th>
                <td mat-cell *matCellDef="let element">
                    {{element.sportType}}
                </td>
            </ng-container>
            <ng-container matColumnDef="sportSeason">
                <th mat-header-cell  *matHeaderCellDef mat-sort-header> Season </th>
                <td mat-cell *matCellDef="let element">
                    {{element.sportSeason}}
                </td>
            </ng-container>           
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row matRipple [ngClass]="{'row_select': row.id === this.transferHistory.studentTransferSeasonId }" *matRowDef="let row; columns: displayedColumns;" (click)="edit(row.id)"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
    </div>
    <div class="col-sm-6" *ngIf="isShown" [ngClass]="{disabledDiv: !WriteCompliance}">
        <div [formGroup]="transferHistoryFormGroup">
            <div style="text-align: right;" *ngIf="WriteCompliance">
                <button mat-raised-button color="primary" [disabled]="!transferHistoryFormGroup.valid"
                    (click)="onSubmit()">
                    <mat-icon>save</mat-icon> {{this.transferHistory && this.transferHistory.studentTransferSeasonId !== null ? 'Update': 'Save'}}
                </button>
                &nbsp;
                <button mat-raised-button (click)="cancel()">
                    Cancel
                </button>
                &nbsp;
                <button color="warn" *ngIf="this.transferHistory && this.transferHistory.studentTransferSeasonId !== null" (click)="delete(this.transferHistory.studentTransferSeasonId)"  mat-raised-button (click)="cancel()">
                    Delete
                </button>
            </div>
            <br>
            <mat-divider></mat-divider>
            <br>
            <div class="row">
                <div class="col-sm-4">
                    <mat-form-field [hidden]="true">
                        <input matInput formControlName="studentId">
                    </mat-form-field>
                    <mat-form-field [hidden]="true">
                        <input matInput formControlName="tenantId">
                    </mat-form-field>
                    <mat-form-field [hidden]="true">
                        <input matInput formControlName="studentTransferSeasonId">
                    </mat-form-field>

                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Sport</mat-label>
                        <mat-select required formControlName="sportTypeId">
                            <mat-option>--SELECT--</mat-option>                          
                            <ng-container *ngFor="let item of sportTypeList">
                                <mat-option *ngIf="evalBind(item,transferHistory.sportTypeId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Season</mat-label>
                        <mat-select required formControlName="sportSeasonId">
                            <mat-option>--Select--</mat-option>                          
                            <ng-container *ngFor="let item of sportSeasonList">
                                <mat-option *ngIf="evalBind(item,transferHistory.sportSeasonId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-4">
                </div>
            </div>
            <div class="row">
                <div class="col-sm-8">                    
                    <mat-form-field [hidden]="true">
                        <input matInput formControlName="institutionId">
                    </mat-form-field>
                    <div *ngIf="this.transferHistory.institutionId != null; else elseBlock">
                        <span>University</span><br />
                        <span><strong>{{this.transferHistory.institutionDescription}}</strong></span>
                    </div>
                    <ng-template #elseBlock>
                    <mat-form-field style="display:flex;flex-direction: column;">
                        <mat-label>University</mat-label>
                        <input matInput required (focus)="openDialog()" formControlName="institutionDescription" placeholder="University">
                    </mat-form-field>
                </ng-template>
                </div>
                <div class="col-sm-4" *ngIf="WriteCompliance" >
                    <button mat-raised-button color="primary" style="float: right;" (click)="openDialog()">
                        <mat-icon>{{this.transferHistory.institutionId != null ? 'edit':'search'}}</mat-icon>  
                        {{this.transferHistory.institutionId != null ? 'Edit':'Search'}}
                    </button>
                </div>
            </div>
            <br/>
            <div class="row">
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Participation</mat-label>
                        <mat-select formControlName="participationTypeId">
                            <mat-option>--Select--</mat-option>                          
                            <ng-container *ngFor="let item of sportParticipationList">
                                <mat-option *ngIf="evalBind(item,transferHistory.participationTypeId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-4">
                </div>
                <div class="col-sm-4">
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <mat-checkbox formControlName="isJuniorCollege" style="margin-top: 25px;width: 50%;">Junior College
                    </mat-checkbox>
                </div>
                <div class="col-sm-4">
                </div>
                <div class="col-sm-4">
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <mat-checkbox formControlName="isMedicalHardship" style="margin-top: 25px;width: 50%;">Hardship
                    </mat-checkbox>
                </div>
                <div class="col-sm-4">
                </div>
                <div class="col-sm-4">
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <mat-checkbox formControlName="isJuniorCollegeGraduate" style="margin-top: 25px;width: 50%;">
                        Graduated
                    </mat-checkbox>
                </div>
                <div class="col-sm-4">
                </div>
                <div class="col-sm-4">
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>P/Q/N</mat-label>
                        <mat-select formControlName="freshmanQualificationTypeId">
                            <mat-option>--Select--</mat-option>                           
                            <ng-container *ngFor="let item of ftrs">
                                <mat-option *ngIf="evalBind(item,transferHistory.freshmanQualificationTypeId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-4">
                </div>
                <div class="col-sm-4">
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Renewed Aid</mat-label>
                        <mat-select formControlName="athleticFinancialAidRenewalTypeId">
                            <mat-option>--Select--</mat-option>                          
                            <ng-container *ngFor="let item of athleticFinancialAidRenewalTypeList">
                                <mat-option *ngIf="evalBind(item,transferHistory.athleticFinancialAidRenewalTypeId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-4">
                </div>
                <div class="col-sm-4">
                </div>
            </div>
            <br>
            <mat-divider></mat-divider>
            <br>
            <div style="text-align: right;" *ngIf="WriteCompliance">
                <button mat-raised-button color="primary" [disabled]="!transferHistoryFormGroup.valid"
                    (click)="onSubmit()">
                    <mat-icon>save</mat-icon> {{this.transferHistory && this.transferHistory.studentTransferSeasonId !== null ? 'Update': 'Save'}}
                </button>
                &nbsp;
                <button mat-raised-button (click)="cancel()">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</div>
